// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__2RtgN","time":"styles_time__3il4v"};